import { analytics } from '@/lib/analytics'
import { Button, ButtonText } from '@/ui/core/button'
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
} from '@/ui/core/dialog'
import { VStack } from '@/ui/core/stack'
import { useState } from 'react'
import Toast from 'react-native-toast-message'
import { BillingCardForm } from '../BillingCardForm'

const UpdateCardModal = () => {
	const [open, setOpen] = useState(false)

	const onComplete = () => {
		analytics.trackEvent('updated-billing-info')

		setOpen(false)
		Toast.show({
			type: 'success',
			text1: 'Successfully updated card',
		})
	}

	return (
		<Dialog open={open} onOpenChange={setOpen}>
			<DialogTrigger asChild>
				<Button variant="ghost">
					<ButtonText spacing="wide">UPDATE</ButtonText>
				</Button>
			</DialogTrigger>
			<DialogContent variant="billing" className="flex lg:items-center items-start">
				<VStack gap={60} className="lg:w-80 native:w-screen native:px-12">
					<DialogHeader>
						<DialogTitle className="text-5xl font-apercu-bold">
							Your new card.
						</DialogTitle>
					</DialogHeader>
					<VStack gap={24} className="native:pl-6 native:pr-12">
						<BillingCardForm onComplete={onComplete} />
					</VStack>
				</VStack>
			</DialogContent>
		</Dialog>
	)
}

export { UpdateCardModal }
